import { apiFetch } from '../../services/http';
import { getAuthHeaders } from '../../services/authHeaders';
import { TAGS_ENABLED } from '../../services/config';

export interface Tag {
  id: string;
  name: string;
  color: string;
  created_at: string;
}

export const tagsApi = {
  list: (token: string) =>
    TAGS_ENABLED
      ? apiFetch<{ items: Tag[], total: number }>('/v1/app/tags', {
          headers: getAuthHeaders(token),
        })
      : Promise.resolve({ items: [], total: 0 }),
  create: (token: string, data: Partial<Tag>) =>
    TAGS_ENABLED
      ? apiFetch<Tag>('/v1/app/tags', {
          method: 'POST',
          headers: {
            ...getAuthHeaders(token),
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
      : Promise.reject(new Error('Tags feature disabled')),
  delete: (token: string, id: string) =>
    TAGS_ENABLED
      ? apiFetch(`/v1/app/tags/${id}`, {
          method: 'DELETE',
          headers: getAuthHeaders(token),
        })
      : Promise.resolve({ ok: true }),
};
